import { getMetaService } from "../../../services/publicServices";
import { toastErrorMessage } from "../../../utils/toastMessage/toastMessage";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../loadingActions/loadingActions";

export const setMetaAction = () => {
  return async (dispatch) => {
    try {
      await dispatch(setLoadingTrueAction());
      const { status, data } = await getMetaService();
      if (status === 200) {
        await dispatch({
          type: "SET_META",
          payload: data.result,
        });
      }
    } catch ({ response }) {
      toastErrorMessage(
        "خطا در بارگذاری اطلاعات لطفا صفحه را مجدد بارگذاری کنید"
      );
    } finally {
      await dispatch(setLoadingFalseAction());
    }
  };
};
